export const VIEW_COOKIE = 'view'

export enum View {
  Mobile = 'mobile',
  Desktop = 'desktop',
}

export type ViewProps = {
  hasInitialView: boolean
  view: View | null
}
